var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 307 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.168 4.685c18.41 4.702 32.017 21.396 32.017 41.27 0 19.873-13.607 36.567-32.017 41.269v-5.387c15.504-4.565 26.825-18.9 26.825-35.883 0-16.982-11.321-31.318-26.825-35.875V4.685Zm-21.15 82.539C13.607 82.522 0 65.828 0 45.954 0 26.082 13.607 9.388 32.017 4.686v5.394C16.514 14.636 5.192 28.972 5.192 45.955c0 16.982 11.322 31.317 26.825 35.882v5.387Z",
    fill: "url(#logo_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-23 17.16 43.171)",
    fill: "url(#logo_svg__b)",
    d: "M17.16 43.171h46v3.833h-46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(48 42.243 4.76)",
    fill: "url(#logo_svg__c)",
    d: "M42.243 4.761h29.114v3.833H42.243z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(56 18.511 44.296)",
    fill: "url(#logo_svg__d)",
    d: "M18.511 44.296h46v3.833h-46z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-51 42.593 82.808)",
    fill: "url(#logo_svg__e)",
    d: "M42.593 82.808h24.71v3.833h-24.71z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.63,
    cy: 26.833,
    r: 7.241,
    fill: "url(#logo_svg__f)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.63,
    cy: 63.889,
    r: 7.241,
    fill: "url(#logo_svg__g)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.463,
    cy: 45.148,
    r: 7.241,
    fill: "url(#logo_svg__h)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.592,
    cy: 84.759,
    r: 7.241,
    fill: "url(#logo_svg__i)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.592,
    cy: 7.241,
    r: 7.241,
    fill: "url(#logo_svg__j)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.459 40.147c-1.92 0-3.708-.312-5.364-.936a13.393 13.393 0 0 1-4.284-2.7 12.65 12.65 0 0 1-2.808-4.14c-.672-1.584-1.008-3.312-1.008-5.184 0-1.872.336-3.6 1.008-5.184a12.007 12.007 0 0 1 2.844-4.104 12.614 12.614 0 0 1 4.284-2.7c1.632-.648 3.42-.972 5.364-.972 2.064 0 3.948.36 5.652 1.08a11.03 11.03 0 0 1 4.32 3.132l-3.024 2.844c-.912-.984-1.932-1.716-3.06-2.196-1.128-.504-2.352-.756-3.672-.756-1.32 0-2.532.216-3.636.648a8.655 8.655 0 0 0-2.844 1.836 8.723 8.723 0 0 0-1.872 2.808c-.432 1.08-.648 2.268-.648 3.564 0 1.296.216 2.484.648 3.564a8.723 8.723 0 0 0 1.872 2.808 8.655 8.655 0 0 0 2.844 1.836c1.104.432 2.316.648 3.636.648 1.32 0 2.544-.24 3.672-.72 1.128-.504 2.148-1.26 3.06-2.268l3.024 2.88a11.528 11.528 0 0 1-4.32 3.132c-1.704.72-3.6 1.08-5.688 1.08Zm24.212-.36v-25.2h10.368c2.232 0 4.14.36 5.724 1.08 1.608.72 2.844 1.752 3.708 3.096.864 1.344 1.296 2.94 1.296 4.788 0 1.848-.432 3.444-1.296 4.788-.864 1.32-2.1 2.34-3.708 3.06-1.584.696-3.492 1.044-5.724 1.044h-7.776l2.088-2.124v9.468h-4.68Zm16.488 0-6.372-9.144h5.004l6.408 9.144h-5.04Zm-11.808-8.964-2.088-2.232h7.56c2.064 0 3.612-.444 4.644-1.332 1.056-.888 1.584-2.124 1.584-3.708 0-1.608-.528-2.844-1.584-3.708-1.032-.864-2.58-1.296-4.644-1.296h-7.56l2.088-2.304v14.58Zm37.213 8.964v-9.972l1.044 2.88-10.944-18.108h5.004l8.784 14.58h-2.808l8.856-14.58h4.608l-10.944 18.108 1.08-2.88v9.972h-4.68Zm27.012 0v-25.2h10.368c2.232 0 4.14.36 5.724 1.08 1.608.72 2.844 1.752 3.708 3.096.864 1.344 1.296 2.94 1.296 4.788 0 1.848-.432 3.444-1.296 4.788-.864 1.344-2.1 2.376-3.708 3.096-1.584.72-3.492 1.08-5.724 1.08h-7.776l2.088-2.196v9.468h-4.68Zm4.68-8.964-2.088-2.268h7.56c2.064 0 3.612-.432 4.644-1.296 1.056-.888 1.584-2.124 1.584-3.708 0-1.608-.528-2.844-1.584-3.708-1.032-.864-2.58-1.296-4.644-1.296h-7.56l2.088-2.304v14.58Zm35.183 8.964v-21.24h-8.352v-3.96h21.384v3.96h-8.352v21.24h-4.68Zm37.721.36c-1.968 0-3.78-.324-5.436-.972-1.656-.648-3.096-1.548-4.32-2.7a12.485 12.485 0 0 1-2.844-4.104c-.672-1.584-1.008-3.312-1.008-5.184 0-1.872.336-3.588 1.008-5.148a12.007 12.007 0 0 1 2.844-4.104c1.224-1.176 2.664-2.088 4.32-2.736 1.656-.648 3.456-.972 5.4-.972 1.968 0 3.768.324 5.4.972 1.656.648 3.096 1.56 4.32 2.736a12.007 12.007 0 0 1 2.844 4.104c.672 1.56 1.008 3.276 1.008 5.148 0 1.872-.336 3.6-1.008 5.184a12.007 12.007 0 0 1-2.844 4.104c-1.224 1.152-2.664 2.052-4.32 2.7-1.632.648-3.42.972-5.364.972Zm-.036-4.104c1.272 0 2.448-.216 3.528-.648a8.26 8.26 0 0 0 2.808-1.836 8.753 8.753 0 0 0 1.836-2.808c.456-1.08.684-2.268.684-3.564 0-1.296-.228-2.472-.684-3.528a8.26 8.26 0 0 0-1.836-2.808 8.011 8.011 0 0 0-2.808-1.872c-1.08-.432-2.256-.648-3.528-.648-1.272 0-2.448.216-3.528.648a8.472 8.472 0 0 0-2.808 1.872 8.723 8.723 0 0 0-1.872 2.808c-.432 1.056-.648 2.232-.648 3.528 0 1.272.216 2.448.648 3.528a9.154 9.154 0 0 0 1.872 2.844 8.26 8.26 0 0 0 2.808 1.836c1.08.432 2.256.648 3.528.648Zm-174.517 42.64a19.17 19.17 0 0 1-5.652-.828c-1.8-.576-3.228-1.308-4.284-2.196l1.62-3.636c1.008.792 2.256 1.452 3.744 1.98 1.488.528 3.012.792 4.572.792 1.32 0 2.388-.144 3.204-.432.816-.288 1.416-.672 1.8-1.152a2.723 2.723 0 0 0 .576-1.692c0-.768-.276-1.38-.828-1.836-.552-.48-1.272-.852-2.16-1.116a29.515 29.515 0 0 0-2.916-.792 57.309 57.309 0 0 1-3.204-.828 15.265 15.265 0 0 1-2.916-1.26 6.538 6.538 0 0 1-2.124-2.088c-.552-.864-.828-1.968-.828-3.312 0-1.368.36-2.616 1.08-3.744.744-1.152 1.86-2.064 3.348-2.736 1.512-.696 3.42-1.044 5.724-1.044 1.512 0 3.012.192 4.5.576 1.488.384 2.784.936 3.888 1.656l-1.476 3.636a13.386 13.386 0 0 0-3.492-1.476c-1.2-.336-2.352-.504-3.456-.504-1.296 0-2.352.156-3.168.468-.792.312-1.38.72-1.764 1.224-.36.504-.54 1.08-.54 1.728 0 .768.264 1.392.792 1.872.552.456 1.26.816 2.124 1.08.888.264 1.872.528 2.952.792 1.08.24 2.148.516 3.204.828 1.08.312 2.052.72 2.916 1.224a5.807 5.807 0 0 1 2.124 2.052c.552.864.828 1.956.828 3.276a6.77 6.77 0 0 1-1.116 3.744c-.72 1.128-1.836 2.04-3.348 2.736-1.512.672-3.42 1.008-5.724 1.008Zm30.213-.36V68.35l1.044 2.88-10.944-18.108h5.004l8.784 14.58H143.9l8.856-14.58h4.608L146.42 71.23l1.08-2.88v9.972h-4.68Zm34.614.36a19.17 19.17 0 0 1-5.652-.828c-1.8-.576-3.228-1.308-4.284-2.196l1.62-3.636c1.008.792 2.256 1.452 3.744 1.98 1.488.528 3.012.792 4.572.792 1.32 0 2.388-.144 3.204-.432.816-.288 1.416-.672 1.8-1.152a2.723 2.723 0 0 0 .576-1.692c0-.768-.276-1.38-.828-1.836-.552-.48-1.272-.852-2.16-1.116a29.515 29.515 0 0 0-2.916-.792 57.309 57.309 0 0 1-3.204-.828 15.265 15.265 0 0 1-2.916-1.26 6.538 6.538 0 0 1-2.124-2.088c-.552-.864-.828-1.968-.828-3.312 0-1.368.36-2.616 1.08-3.744.744-1.152 1.86-2.064 3.348-2.736 1.512-.696 3.42-1.044 5.724-1.044 1.512 0 3.012.192 4.5.576 1.488.384 2.784.936 3.888 1.656l-1.476 3.636a13.386 13.386 0 0 0-3.492-1.476c-1.2-.336-2.352-.504-3.456-.504-1.296 0-2.352.156-3.168.468-.792.312-1.38.72-1.764 1.224-.36.504-.54 1.08-.54 1.728 0 .768.264 1.392.792 1.872.552.456 1.26.816 2.124 1.08.888.264 1.872.528 2.952.792 1.08.24 2.148.516 3.204.828 1.08.312 2.052.72 2.916 1.224a5.807 5.807 0 0 1 2.124 2.052c.552.864.828 1.956.828 3.276a6.77 6.77 0 0 1-1.116 3.744c-.72 1.128-1.836 2.04-3.348 2.736-1.512.672-3.42 1.008-5.724 1.008Zm29.309-.36v-21.24h-8.352v-3.96h21.384v3.96h-8.352v21.24h-4.68Zm30.584-14.724h12.528v3.852h-12.528v-3.852Zm.36 10.8h14.22v3.924h-18.9v-25.2h18.396v3.924h-13.716v17.352Zm29.157 3.924v-25.2h3.852l11.016 18.396h-2.016l10.836-18.396h3.852l.036 25.2h-4.428l-.036-18.252h.936l-9.216 15.372h-2.088l-9.36-15.372h1.08v18.252h-4.464Z",
    fill: "#12284C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 65.6,
    y1: 113.82,
    x2: -41.53,
    y2: 100.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 52.584,
    y1: 48.24,
    x2: 33.306,
    y2: 20.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__c",
    x1: 64.663,
    y1: 9.829,
    x2: 44.237,
    y2: -8.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__d",
    x1: 53.935,
    y1: 49.365,
    x2: 34.657,
    y2: 21.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__e",
    x1: 61.621,
    y1: 87.876,
    x2: 41.787,
    y2: 72.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__f",
    x1: 63.541,
    y1: 38.74,
    x2: 45.313,
    y2: 36.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__g",
    x1: 63.541,
    y1: 75.796,
    x2: 45.313,
    y2: 73.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__h",
    x1: 21.374,
    y1: 57.055,
    x2: 3.145,
    y2: 54.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__i",
    x1: 46.504,
    y1: 96.666,
    x2: 28.275,
    y2: 94.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__j",
    x1: 46.504,
    y1: 19.148,
    x2: 28.275,
    y2: 16.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FF"
  })))));
};

export { SvgLogo as ReactComponent };
export default __webpack_public_path__ + "logo.svg";